module.exports = __webpack_public_path__ + "img/registro-aubert.6430740e.png";